import React, { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import AuthService from 'services/AuthService';
import KskToast from 'ksk/styledComponents/components/KskToast/KskToast';
import SessionWarningDetails from 'auth/SessionWarningDetails';

const useSessionWarningToast = (sessionWarning, isAuthenticated, sessionExpiresAt) => {
  const toastIdRef = useRef(null);

  const handleExtendSession = (e) => {
    e.stopPropagation();
    if (toastIdRef.current) {
      toast.dismiss(toastIdRef.current);
      toastIdRef.current = null;
    }
    AuthService.getAll();
  };

  useEffect(() => {
    if (sessionWarning && isAuthenticated) {
      if (!toastIdRef.current) {
        toastIdRef.current = toast.warn(
          <KskToast 
            warning 
            showTimer={false}
            details={<SessionWarningDetails expiresAt={sessionExpiresAt} onExtendSession={handleExtendSession} />} 
          />, 
          { autoClose: false, closeOnClick: false }
        );
      }
    } else {
      if (toastIdRef.current) {
        toast.dismiss(toastIdRef.current);
        toastIdRef.current = null;
      }
    }

    return () => {
      if (toastIdRef.current) {
        toast.dismiss(toastIdRef.current);
        toastIdRef.current = null;
      }
    }
  }, [sessionWarning, isAuthenticated, sessionExpiresAt]);
};

export default useSessionWarningToast;
